module.exports = __webpack_public_path__ + "static/img/frown-o.97222c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frown-o.png
// module id = Rapn
// module chunks = 1